import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { genreToSlug } from "../lib/genres";

// Inline, tappable genre names for compact spots (cards, hero meta, detail meta).
// Inherits surrounding text color; adds an accent hover. Stops click propagation
// so tapping a genre inside a clickable card doesn't also open the title.
export function GenreLinks({ genres, max, sep = " • ", className = "" }) {
  const navigate = useNavigate();
  if (!genres || !genres.length) return null;
  const list = max ? genres.slice(0, max) : genres;
  return (
    <>
      {list.map((g, i) => (
        <Fragment key={g}>
          {i > 0 && <span aria-hidden="true">{sep}</span>}
          <button
            type="button"
            data-testid={`genre-chip-${genreToSlug(g)}`}
            onClick={(e) => { e.stopPropagation(); navigate(`/genre/${genreToSlug(g)}`); }}
            className={`cursor-pointer underline-offset-2 transition-colors hover:text-[var(--accent)] hover:underline ${className}`}
          >
            {g}
          </button>
        </Fragment>
      ))}
    </>
  );
}

// Pill-style genre chips for roomy spots (genre view, future use).
export function GenrePills({ genres, className = "", activeSlug }) {
  const navigate = useNavigate();
  if (!genres || !genres.length) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {genres.map((g) => {
        const slug = genreToSlug(g);
        return (
          <button
            key={g}
            type="button"
            data-testid={`genre-pill-${slug}`}
            onClick={() => navigate(`/genre/${slug}`)}
            className={`genre-pill ${activeSlug === slug ? "genre-pill-active" : ""}`}
          >
            {g}
          </button>
        );
      })}
    </div>
  );
}
